import { Component, Inject, OnInit, ViewChild, ElementRef, AfterViewInit, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA as MAT_DIALOG_DATA, MatDialogRef as MatDialogRef } from '@angular/material/dialog';
import { HoveredIncadea } from 'src/services/incadea/incadea-interfaces/HoveredData.interface';
import { FormGroup, FormControl, Validators, ReactiveFormsModule, AbstractControl } from '@angular/forms';
import { IncadeaAppointment } from 'src/services/api-services/api-interfaces/IBAppointmentGET.interface';
import { Observable, tap, Subscription, of, concat, map } from 'rxjs';
import { Location, ResponseCompanies } from 'src/services/incadea/incadea-interfaces/responses/ResponseCompanies.interface';
import { RespDeptMakes } from 'src/services/incadea/incadea-interfaces/responses/ResponseDeptMakes.interface';
import { ResponseServices } from 'src/services/incadea/incadea-interfaces/responses/ResponseServices.interface';
import { ResponseResources } from 'src/services/incadea/incadea-interfaces/responses/ResponseResources.interface';
import { HelperService } from 'src/services/helperService';
import { GetCompaniesService } from 'src/services/incadea/incadea-services/getCompanies.service';
import { GetDepartmentsService } from 'src/services/incadea/incadea-services/getDepartments.service';
import { GetMakesService } from 'src/services/incadea/incadea-services/getMakes.service';
import { GetServicesService } from 'src/services/incadea/incadea-services/getServices.service';
import { GetResourcesService } from 'src/services/incadea/incadea-services/getResources.service';
import { GetTimeSlotsService } from 'src/services/incadea/incadea-services/getTimeSlots.service';
import { ResponseTimeSlots } from 'src/services/incadea/incadea-interfaces/responses/ResponseTimeSlots.interface';
import { MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { GetAppointmentCreate } from 'src/services/incadea/incadea-services/getAppointmentCreate.service';
import { IncadeaBookingService } from 'src/services/api-services/IncadeaBooking.service';
import { ABappointment } from 'src/services/api-services/api-interfaces/IBAppointment.interface';
import { AppointmentCreate } from 'src/services/incadea/incadea-interfaces/requests/RequestAppointmentCreate.interface';
import { ResponseAppointment } from 'src/services/incadea/incadea-interfaces/responses/ResponseAppointment.interface';
import { ThemePalette } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';

import { typeOfService } from '../../../../../services/api-services/api-interfaces/typeOfService.interface';
import { vehicle } from '../../../../../services/incadea/incadea-interfaces/requests/RequestAppointmentCreate.interface';
import { TitleCasePipe } from '@angular/common';

import DocumentType from 'src/services/api-services/api-interfaces/documentType.interface';
import { APIDocumentTypeService } from 'src/services/api-services/api-document-type.service';
import { VehicleRelationship } from 'src/services/api-services/api-interfaces/vehicleRelationship.interface';
import { APIVehicleRelationship } from 'src/services/api-services/api-vehicle-relationship.service';
import { Departments } from '../../../../../services/incadea/incadea-interfaces/responses/ResponseOrderDetails.interface';
import moment from 'moment';
function yesSelectedValidator(control: AbstractControl) {
  const value = control.value;
  if (value === 'si') {
    return null; // The form is valid
  } else {
    return { 'yesSelected': true }; // The form is invalid
  }
}
const noSpecialCharsValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const noSpecialChars = /^[^*=,\/#!$%\^\*;:{}\[\]~()<>\?|]+$/;
  const forbidden = !noSpecialChars.test(control.value);
  return forbidden ? {'noSpecialChars': {value: control.value}} : null;
};
const emailValidator = (control: AbstractControl): {[key: string]: any} | null => {
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
  const forbidden = !emailPattern.test(control.value);
  return forbidden ? {'invalidEmail': {value: control.value}} : null;
};
@Component({
    selector: 'app-reschedule',
    templateUrl: './reschedule.dialog.html',
    styleUrls: ['../../../../scheduling/dialogs/reschedule-appointment/reschedule-appointment.dialog.sass'],
    providers: [TitleCasePipe],
    standalone: false
})
export class RescheduleDialog implements OnInit, AfterViewInit {
  @ViewChild('picker') picker!: MatDatepicker<Date>;
isLoadingSave=false;
isSaving = false;
companies$= new Observable<ResponseCompanies[]>();
departments$= new Observable<RespDeptMakes[]>();
makes$= new Observable<RespDeptMakes[]>();
services$= new Observable<ResponseServices[]>()
resources$= new Observable<ResponseResources[]>()
locations?:Location[]= []
isEditable: boolean = false;
RescheduleForm: FormGroup;
ReprensentativeForm: FormGroup;
termsAndConditions: FormGroup;
initialFormData : IncadeaAppointment = this.appointment.dataItem
token$?: Observable<string>
tokenString=''
dateAndTime=''
timeSlots: ResponseTimeSlots[] =[]
calendarRange:{start:Date, end:Date}={} as {start:Date, end:Date}
currentDate = new Date();
selectedMonth: number = new Date().getMonth()
rightArrow: HTMLButtonElement | null = null;
leftArrow : HTMLButtonElement | null = null;
calendarButton: HTMLButtonElement | null = null;
availableHours: string[]=[this.initialFormData.Start]
showEditForm: boolean = false
isFirstLoad:boolean = true;
dataCreationAppointmentBooking!:  ABappointment;
documentType:DocumentType[] = []
relationshipCustomerVehicle: VehicleRelationship[]  = []
isEditingRepresentatives:string='true';
channel= [
  "Post",
  "Email",
  "Phone",
  "MobilePhone",
  "Fax",
  "SMS",
  "WhatsApp",
  "FbMessenger",
  "WeChat",
];
slotDuration= 15
charCount: number = 0;


  constructor(
    @Inject(MAT_DIALOG_DATA) public appointment : HoveredIncadea,
    public VehicleRelationshipService: APIVehicleRelationship,
    public typeOfDocumentService: APIDocumentTypeService,

    public titleCasePipe: TitleCasePipe,
    public helperService: HelperService,
    public getCompaniesService : GetCompaniesService,
    public getDepartmentsService: GetDepartmentsService,
    public getMakesService: GetMakesService,
    public getServicesService:GetServicesService,
    public getResourcesServices: GetResourcesService,
    public getTimeSlots:GetTimeSlotsService,
    public getAppointmentCreate : GetAppointmentCreate,
    public getCreateIncadeaBooking: IncadeaBookingService,
    public dialogRef: MatDialogRef<RescheduleDialog>,

    private translate: TranslateService,
  ) {

    //  console.log(this.appointment)

    if(this.initialFormData.Comment === "null"){
      this.initialFormData.Comment = ""
    }
    this.RescheduleForm= new FormGroup({
      fullName:  new FormControl( this.initialFormData.CustomerName, Validators.required),
      docType: new FormControl( "", Validators.required),
      documentNumber: new FormControl(this.initialFormData.CustomerId, Validators.required),
      customerRelationshipVehicle: new FormControl("", Validators.required),
      phone: new FormControl( this.initialFormData.CustomerPhoneNo, Validators.required),
      email: new FormControl( this.initialFormData.CustomerEmail, [Validators.required,emailValidator,noSpecialCharsValidator]),
      plate: new FormControl( this.initialFormData.LicenseNo, Validators.required),
      vin: new FormControl( this.initialFormData.VIN,),
      brand: new FormControl( this.initialFormData.Make, Validators.required),
      company: new FormControl( this.initialFormData, Validators.required),
      location: new FormControl( this.initialFormData.LocationId, Validators.required),
      department: new FormControl( {Code:this.initialFormData.Department}, Validators.required),
      make: new FormControl( {Code:this.initialFormData.Make}, Validators.required),
      resource: new FormControl( {Id:this.initialFormData.Resources[0].ResourceId}, Validators.required),
      typeOfService: new FormControl( {Id:this.initialFormData.Services[0].ServiceId}, Validators.required),
      mileAge: new FormControl( this.initialFormData.Mileage, Validators.required),
      date: new FormControl("",Validators.required),
      time: new FormControl("", Validators.required),
      channel: new FormControl(this.initialFormData.DataPrivacyConsent[0].CommunicationChannels),
      comments: new FormControl( this.initialFormData.Comment),
      ownerShowUp: new FormControl( this.initialFormData.IsCustomerPresent),
    })
    if(this.initialFormData.Representative){
        this.ReprensentativeForm= new FormGroup({
          fullName: new FormControl( this.initialFormData.Representative[0].RepresentativeFullName, Validators.required),
          docType: new FormControl( this.initialFormData.Representative[0].DocumentType, Validators.required),
          documentNumber: new FormControl(this.initialFormData.Representative[0].DocumentNumber, Validators.required),
          phone: new FormControl( this.initialFormData.CustomerPhoneNo, [Validators.required, Validators.pattern('^[0-9]*$')]),
          email: new FormControl( this.initialFormData.Representative[0].Email, Validators.required),

        })
      }
      else {

        this.ReprensentativeForm= new FormGroup({
          fullName: new FormControl( "", Validators.required),
          docType: new FormControl("", Validators.required),
          documentNumber: new FormControl("", Validators.required),
          phone: new FormControl( "", [Validators.required, Validators.pattern('^[0-9]*$')]),
          email: new FormControl( "", Validators.required),

        })
      }
    this.termsAndConditions= new FormGroup({
      acceptProtectionPolicy: new FormControl( false, Validators.requiredTrue),
      acceptTermsAndConditions: new FormControl(false, Validators.requiredTrue),

    })



  }
  ngOnInit(): void {

    const docTypes= this.typeOfDocumentService.GetByCountryId(this.helperService.user.countryId)
    .subscribe({
     next:(typesOfDocument)=>{
      this.documentType= typesOfDocument
      const matchDocType=  this.documentType.find(doc=>doc.typeId===this.initialFormData.DocumentTypeId)
    if(this.initialFormData.Representative){
      const matchDocTypeRepresentative=  this.documentType.find(doc=>doc.typeId===this.initialFormData.Representative[0].DocumentType)
      if (matchDocTypeRepresentative) {
      this.ReprensentativeForm.get('docType')!.patchValue(matchDocTypeRepresentative)
      }
    }

      if (matchDocType) {
        this.RescheduleForm.get('docType')!.patchValue(matchDocType)
      }


    },
    complete: ()=>{docTypes.unsubscribe},

      error: (error) => {
        // Manejo de error 401
        if (error.status === 401) {
          this.helperService.logoutToken();
        }

        const translateTxtNotMatch = this.translate.instant("notMatchFound")

        this.helperService.showAlert =true
        this.helperService.typeAlert ="warning"
        this.helperService.messageAlert =translateTxtNotMatch
        setTimeout(() => {
          this.helperService.showAlert =false
          }, 7000)
      }

     })
      const relationshipssubscribe =this.VehicleRelationshipService.getAllVehicleRelationships().subscribe({
        next: (relationships)=>{

          this.relationshipCustomerVehicle= relationships
          const matchRelationship = this.relationshipCustomerVehicle.find(rel=>rel.relationshipVehicleId===this.initialFormData.RelationshipVehicleId)

          if (matchRelationship) {

            this.RescheduleForm.get('customerRelationshipVehicle')?.patchValue(matchRelationship)

          }

        },
        complete: ()=>{
          relationshipssubscribe.unsubscribe()
        },
        error: (error) => {
          // Manejo de error 401
          if (error.status === 401) {
            this.helperService.logoutToken();
          }
        }
      })
      this.token$= this.helperService.token.pipe(tap({
        next: (token:string)=>{
        this.companies$= this.getCompaniesService.getCompanies(token,this.helperService.user.incadeaBackendCode!).pipe(tap({
          next: (companies)=>{
            const defaultCompany =this.initialFormData.CompanyId

            const matchCompany= companies.find(company => company.Id.toLowerCase()=== defaultCompany.toLowerCase())

            this.locations= matchCompany?.Locations
            const matchLocation = matchCompany?.Locations.find(location => location.Id=== this.initialFormData.LocationId)


            this.RescheduleForm.patchValue({
              company:matchCompany,
              location: matchLocation,

            })


            const concatFunctions = concat(
              of(this.onLocationChange()),
              of(this.getLocationsDepartmentsAndMakes()),
              of(this.onMakeChange()),
              of(this.onResourceChange()),


            );

            let concatSubscribe = new Subscription
            concatSubscribe = concatFunctions.subscribe({
              complete: () => {
                concatSubscribe.unsubscribe();
              }
            })

          }
        }))
        this.tokenString=token
      },
       }))

    }
  editOwner(){
    this.showEditForm= !this.showEditForm
    this.isEditable=false
  }
  newOwner(){
    if ( !this.showEditForm) {
      this.showEditForm= true
    }
   this.RescheduleForm.patchValue({
    fullName: '',
    docType:'',
    documentNumber:'',
    customerRelationshipVehicle:'',
    phone:'',
    email:''
   })
    this.isEditable=false
  }
  ngAfterViewInit() {
    const toggleButton = document.querySelector('.mat-datepicker-toggle') as HTMLElement;
    toggleButton.addEventListener('click', () => {
      this.calendarButton=  document.querySelector('.mat-focus-indicator.mat-calendar-period-button.mat-button.mat-button-base')  as HTMLButtonElement;
      this.leftArrow = document.querySelector('.mat-calendar-previous-button')  as HTMLButtonElement;
      this.leftArrow!.addEventListener('click', () => {

        this.leftArrow!.style.display= 'none';
        this.rightArrow!.style.display="none"
        this.getCalendarRange(this.selectedMonth)
        this.selectedMonth--
        this.calendarRange= this.getCalendarRange(this.selectedMonth)
        this.onResourceChange()
      });
      this.rightArrow = document.querySelector('.mat-calendar-next-button') as HTMLButtonElement
      this.rightArrow!.addEventListener('click', () => {
        this.rightArrow!.style.display="none"
        this.leftArrow!.style.display= 'none';
        this.getCalendarRange(this.selectedMonth)
        this.selectedMonth++
        this.calendarRange= this.getCalendarRange(this.selectedMonth)
        this.onResourceChange()
      });
    });

  }

  toggleButtons(){
    this.isEditable= !this.isEditable
  }
  getLocationsDepartmentsAndMakes = ()=>{
        const selectedCompany = this.RescheduleForm.get('company')!.value
    this.locations= selectedCompany.Locations
    this.departments$=this.getDepartmentsService.getDepartments(this.tokenString,selectedCompany.Id,this.helperService.user.incadeaBackendCode!).pipe(tap({
      next:(department)=>{
        const departmentMatch = department.find(department => department.Code=== this.RescheduleForm.get('department')!.value.Code)
        this.RescheduleForm.get('department')?.patchValue(departmentMatch)

        //console.log(departmentMatch);


          this.makes$= this.getMakesService.getMakes(this.tokenString,selectedCompany.Id,this.helperService.user.incadeaBackendCode!).pipe(
            tap((makes) =>{
              const makeMatch = makes.find(make => make.Code=== this.RescheduleForm.get('make')!.value.Code)
              this.RescheduleForm.get('make')?.patchValue(makeMatch)
            }),
           )}
    }))

  }

  clearFilters(filters:string){
    switch (filters) {
      case "location":
        this.RescheduleForm.value.department= ''
        this.RescheduleForm.value.make= ''
        this.RescheduleForm.value.typeOfService= ''
        this.RescheduleForm.get('typeOfService')?.patchValue("")
        this.departmentControl.setValue("");
        this.makeControl.setValue("");
        this.typeOfServiceControl.setValue("");
        this.RescheduleForm.get('resource')?.patchValue("")
        this.RescheduleForm.value.resource= ''

        break;
      case "department":
        this.typeOfServiceControl.setValue("");
        this.RescheduleForm.get('typeOfService')?.patchValue("")
        this.RescheduleForm.get('resource')?.patchValue("")
        this.RescheduleForm.value.make= ''
        this.RescheduleForm.value.typeOfService= ''
        this.makeControl.setValue("");
        this.RescheduleForm.value.resource= ''

        break;
      case "make":
        this.typeOfServiceControl.setValue("");
        this.RescheduleForm.get('typeOfService')?.patchValue("")
        this.RescheduleForm.get('resource')?.patchValue("")
        this.RescheduleForm.value.resource= ''
        break;

        case "typeOfService":
          this.RescheduleForm.get('resource')?.patchValue("")
          this.RescheduleForm.value.resource= ''
        break;

    }

  }
  onLocationChange(){


    const companyId : string = this.RescheduleForm.get('company')!.value.Id
    const locationId : string = this.RescheduleForm.get('location')!.value.Id

    this.departments$=this.getDepartmentsService.getDepartments(this.tokenString,companyId,this.helperService.user.incadeaBackendCode!).pipe(tap({
      next:(department)=>{
        //console.log(departmentMatch);
          this.makes$= this.getMakesService.getMakes(this.tokenString,companyId,this.helperService.user.incadeaBackendCode!)

           }
    }))

    }

  onMakeChange(){
    //console.log(this.RescheduleForm.get('department')!.value);


    const companyId : string = this.RescheduleForm.get('company')!.value.Id
    const locationId : string = this.RescheduleForm.get('location')!.value.Id
    const departmentCode: string = this.RescheduleForm.get('department')!.value.Code
    const makeCode: string = this.RescheduleForm.get('make')!.value.Code
   //console.log(companyId, locationId, departmentCode, makeCode);

   this.resources$= this.getResourcesServices.getResources(this.tokenString, companyId,  locationId,this.helperService.user.incadeaBackendCode!,departmentCode).pipe(
    map((resources) =>{
      const resourceMatch = resources.find(resource => resource.Id=== this.RescheduleForm.get('resource')!.value.Id)

      this.RescheduleForm.get('resource')?.patchValue(resourceMatch)
     return resources.filter(resource =>
        resource.Type === 'ServiceAdvisor')}),
   ),
   tap()

    this.services$=this.getServicesService.getServices(this.tokenString, companyId , locationId, departmentCode, makeCode,this.helperService.user.incadeaBackendCode!)
    .pipe(
      map((service)=>
    service.filter(service =>
       service.Department === departmentCode)
  ),tap((services)=>{

    const matchService= services.find(service => service.Id === this.RescheduleForm.get('typeOfService')!.value.Id)
    this.RescheduleForm.get('typeOfService')?.patchValue(matchService)

  }

  )
  )
  }

  onResourceChange(){


    const companyId : string = this.RescheduleForm.get('company')!.value.Id
    const locationId : string = this.RescheduleForm.get('location')!.value.Id
    const ResourceId: string = this.RescheduleForm.get('resource')!.value.Id
    const serviceId: string = this.RescheduleForm.get('typeOfService')!.value.Id
    this.calendarRange= this.getCalendarRange(this.selectedMonth)
    this.getTimeSlots.getTimeSlots(
      this.tokenString,
      companyId,
      locationId,
      this.calendarRange.start.toISOString(),
      this.calendarRange.end.toISOString(),
      [ResourceId],
      [{Id:serviceId}],this.helperService.user.incadeaBackendCode!).subscribe({
        next:(timeSlots)=>{
          if(timeSlots.length>0){
            this.timeSlots= timeSlots
            const diferentInMinutes =  (Number( new Date(this.timeSlots[0].To)) - Number(new Date( this.timeSlots[0].From))) / 60000;
            this.slotDuration = diferentInMinutes
            const initialDate = {value:new Date(this.initialFormData.Start) }
            this.isLoadingSave=true;

            this.setHoursOptions(initialDate as MatDatepickerInputEvent<Date>)
            if (this.rightArrow&& this.leftArrow) {
              this.rightArrow.style.display = "inline-block";
              this.leftArrow.style.display = "inline-block";
              this.calendarButton?.click()
            setTimeout(() => {
              // to click twice the change view button and reload calendar
              this.calendarButton?.click()
            }, 1);

              }
          }else{this.isLoadingSave=true;}
        },
      })
  }

  getCalendarRange(month:number):{start:Date, end:Date} {
      const fechaActual = new Date();
      const añoActual = fechaActual.getFullYear();
      const startMonth = new Date(añoActual, month, 1);
      const endMonth = new Date(añoActual, month + 1, 0,24,0,0);

      return { start: startMonth, end: endMonth };
  }
  dateFilter = (date: Date | null): boolean => {
    if (!date) {
      return false;

    } else{

      const selectedDate = date.toISOString().split('T')[0];

      const foundTimeSlot = this.timeSlots.find(timeSlot => {
        const timeSlotDate = timeSlot.From.split('T')[0];
        return selectedDate === timeSlotDate;
      });

      return foundTimeSlot?  true: false;
    }



  }
  setHoursOptions(event: MatDatepickerInputEvent<Date>){
    const eventDate = event.value?.toISOString().split("T")[0]
    const filterTimeSlots = this.timeSlots.filter(timeSlot => timeSlot.From.split('T')[0]===eventDate)
    this.availableHours = filterTimeSlots.map(timeSlot => timeSlot.From)

  }

  onSubmit(){
    this.isLoadingSave=false;
    //call all required methods
    let limitDate = new Date().getFullYear() + '-' +('0' + (new Date().getMonth() + 3) ).slice(-2) + '-' + "15" + 'T23:59:00'
    if(new Date().getMonth() + 3 > 12){
    limitDate = new Date().getFullYear()+1 + '-' +('0' + (new Date().getMonth() + 3 - 12) ).slice(-2) + '-' +  "15" + 'T23:59:00'
    }

    const companyId:string=this.RescheduleForm.get('company')?.value.Id
    const Vehicle={
      Vin:String (this.RescheduleForm.get("vin")?.value),
      LicenseNo:String (this.RescheduleForm.get("plate")?.value),
      Make:String ( this.RescheduleForm.get("make")?.value.Code),
      Department:String ( this.RescheduleForm.get("department")?.value.Code),
      }
    const Customer={
      Name:String (this.RescheduleForm.get("fullName")?.value),
      Phone: {
        PhoneNo: String(this.ReprensentativeForm.get("phone")?.value),
        Type:"Business"
      },
      Email: {
        Email:String(this.RescheduleForm.get("email")?.value),
        Type:"Business"
      },
      IsCustomerPresent:this.RescheduleForm.get('ownerShowUp')!.value? "1" : "0"
    }


    const DataPrivacyConsent=[{
      Beneficiary: this.RescheduleForm.get('department')!.value.Description,
      Purpose:{
        Type:"Business",
        CommunicationChannels:[this.initialFormData.DataPrivacyConsent[0].CommunicationChannels]
      },
      Description: String(this.RescheduleForm.get("comments")?.value.Id),
      ExpirationDate:String(limitDate),
      CreatedOn:new Date().getFullYear() + '-' +('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2) + 'T' + ('0' + new Date().getHours()).slice(-2) + ':' +('0' + new Date().getMinutes()).slice(-2)+ ':' +('0' + new Date().getSeconds()).slice(-2)
      }]
    const appointmentData:AppointmentCreate={
      LocationId: this.RescheduleForm.get('location')!.value.Id,
      Vehicle:Vehicle,
      Customer:Customer,
      TimeslotFrom:(this.RescheduleForm.get("time")?.value),
      PreferredPaymentMethod: "EF",
      Comment:String(this.RescheduleForm.get("comments")?.value),
      ResourceIds: [this.RescheduleForm.get('resource')!.value.Id],
      services:[{Id:this.RescheduleForm.get('typeOfService')!.value.Id}],
      DataPrivacyConsent
    }


    //let serviceNameSelected= this.RescheduleForm.controls.
    this.getAppointmentCreate.cancelAppointmnet(this.tokenString, this.initialFormData.CompanyId,this.initialFormData.AppointmentId,this.helperService.user.incadeaBackendCode! ).subscribe(
      (response)=>{

      if(response.status === 200){
        this.getAppointmentCreate.postAppointmnet(this.tokenString, this.RescheduleForm.get('company')!.value.Id, appointmentData,this.helperService.user.incadeaBackendCode!).pipe(tap((response)=>{
          if (response.AppointmentId) {
            this.createApointmentBooking(response)
            // this.isLoadingSave=true

            }
          })).subscribe()
        }
        if(response.status=== 400 || response.status=== 500){
          console.error(response,"cita no cancelada")
        }
      })
   }
  createApointmentBooking(response:ResponseAppointment){
    // this.documentType$ = this.typeOfDocumentService.getAllDocumentTypes().pipe(tap((typeDoc)=>{
    //   const matchType=typeDoc.find((x)=>x.typeId===this.initialFormData.DocumentTypeId)
    //   this.RescheduleForm.get('docType')?.patchValue(matchType?.typeName)
    //   console.log(typeDoc);
    // }))

    let limitDate = new Date().getFullYear() + '-' +('0' + (new Date().getMonth() + 3) ).slice(-2) + '-' + "15" + 'T23:59:00'
    if(new Date().getMonth() + 3 > 12){
    limitDate = new Date().getFullYear()+1 + '-' +('0' + (new Date().getMonth() + 3 - 12) ).slice(-2) + '-' +  "15" + 'T23:59:00'
    }
    const Representative= {
      DocumentNumber:String(this.ReprensentativeForm.get("documentNumber")?.value),
      DocumentType:String(this.ReprensentativeForm.get("docType")?.value.typeId) ?? "0",
      RepresentativeFullName:String(this.ReprensentativeForm.get("fullName")?.value),
      Email: String(this.ReprensentativeForm.get("email")?.value)
      }
    const createAppointment:ABappointment ={
      AppointmentId:          response.AppointmentId,
      DocumentNo:             response.DocumentNo,
      CompanyId:              this.RescheduleForm.get('company')!.value.Id,
      CompanyName:            this.RescheduleForm.get('company')!.value.Name,
      LocationName:           this.RescheduleForm.get('location')!.value.Description,
      LocationId: this.RescheduleForm.get('location')!.value.Id,
      CountryId:String(this.helperService.user.countryId),
      UserId:String(this.helperService.user.userid) ,
      Vehicle:{
        VIN: String ( this.RescheduleForm.get("vin")?.value),
        LicenseNo: String(this.RescheduleForm.get("plate")?.value),
        Make:String (this.RescheduleForm.get("make")?.value.Code),
        Department:String (this.RescheduleForm.get("department")?.value.Code),
        MakeName: String  ( this.RescheduleForm.get("make")?.value.Description),
        DepartmentName:( this.RescheduleForm.get("department")?.value.Description),
        RelationshipVehicle:String(this.RescheduleForm.get('customerRelationshipVehicle')?.value.relationshipVehicleId),
        Mileage:String(this.RescheduleForm.get("mileAge")?.value)
      },
      Customer:{
        CustomerId:String (this.RescheduleForm.get("documentNumber")?.value),
        DocumentTypeId:String (this.RescheduleForm.get("docType")?.value.typeId),
        Name:String (this.RescheduleForm.get("fullName")?.value),
        Phone:{
          PhoneNo:String(this.RescheduleForm.get("phone")?.value),
          Type:"Business"
        },
        Email:{
          Email:String(this.RescheduleForm.get("email")?.value),
          Type:"Business"
        },
        IsCustomerPresent:this.RescheduleForm.get('ownerShowUp')!.value? "1" : "0"
      },
      Representative:Representative,


      TimeslotFrom:(this.RescheduleForm.get("time")?.value),
      Duration:String(this.slotDuration),
      PreferredPaymentMethod :"EF",
      Comment: String ( this.RescheduleForm.get("comments")?.value),
      SchedulerStatusId: String(1),
      CountryName: String(this.RescheduleForm.get('location')!.value.Address.Country),
      ResourceIds:[{ ResourceId:this.RescheduleForm.get('resource')!.value.Id,ResourceName:this.RescheduleForm.get('resource')!.value.Description}],
      Services:[{ServiceName:this.RescheduleForm.get('typeOfService')!.value.Name,Id:this.RescheduleForm.get('typeOfService')!.value.Id}],
      DataPrivacyConsent:[{
        Beneficiary: typeof this.RescheduleForm.get('department')?.value === 'string'
        ? this.RescheduleForm.get('department')?.value
        : this.RescheduleForm.get('department')?.value?.Code ?? '',
        Purpose:{
          Type:"Business",
          CommunicationChannels:[this.initialFormData.DataPrivacyConsent[0].CommunicationChannels]
        },
        Description:String ( this.RescheduleForm.get("comments")?.value),
        ExpirationDate:  limitDate,
        CreatedOn: new Date().getFullYear() + '-' +('0' + (new Date().getMonth() + 1)).slice(-2) + '-' + ('0' + new Date().getDate()).slice(-2) + 'T' + ('0' + new Date().getHours()).slice(-2) + ':' +('0' + new Date().getMinutes()).slice(-2)+ ':' +('0' + new Date().getSeconds()).slice(-2)

       }],
        UtmSource:"" ,
        UtmCampaign:"" ,
        UtmMedium:"" ,
        UtmContent:"" ,
        UtmTerm: "",
        RecaptchaToken:"ok"
      
    }
    // console.log(createAppointment)
    this.dateAndTime = this.titleCasePipe.transform(`${ new Date(this.RescheduleForm.get("time")?.value).toLocaleDateString(this.helperService.user.language, { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })} ${moment(this.RescheduleForm.get("time")?.value).format('h:mm a')} `);

    this.getCreateIncadeaBooking.upDateIBAppointment(createAppointment,this.initialFormData.AppointmentId).pipe(tap((response)=>{
      if (response.message === "Appointment Updated Successfully.") {

            const oldAppointmentId = this.initialFormData.AppointmentId

            const updateAppointment ={
              oldAppointmentId,
              createAppointment,
            }
            const translateMessage = this.translate.instant('ReScheduleEditedSuccess', {
              ServiceName: this.RescheduleForm.get('typeOfService')!.value.Description,
              TimeSlot: this.dateAndTime
            })

            this.helperService.showAlert =true
            this.helperService.typeAlert ="success"
            this.helperService.messageAlert =translateMessage
            setTimeout(() => {
              this.helperService.showAlert =false
              }, 7000)
            this.isLoadingSave=true;
            this.dialogRef.close(updateAppointment);
      }
    })).subscribe({
      error: (error) => {
        // Validation 401 error
        if(error.status === 401){
          this.helperService.logoutToken()
        }
      }
    })

  }

  formsValidations(): boolean {

    if (this.RescheduleForm.get('ownerShowUp')!.value) {
      const isFormValidation2Invalid =this.RescheduleForm!.invalid  || this.termsAndConditions!.invalid;
      return isFormValidation2Invalid;
    } else {
      if (this.RescheduleForm!.invalid  || this.termsAndConditions!.invalid) {
        return true;
      } else {
        return this.ReprensentativeForm!.invalid;
      }
    }

  }

  get departmentControl(): FormControl {
    return this.RescheduleForm.get('department') as FormControl;
  }

  get makeControl(): FormControl {
    return this.RescheduleForm.get('make') as FormControl;
  }

  get typeOfServiceControl(): FormControl {
    return this.RescheduleForm.get('typeOfService') as FormControl;
  }

  get termsControl(): FormControl {
    return this.termsAndConditions.get('acceptTermsAndConditions') as FormControl;
  }

  get policiesControl(): FormControl {
    return this.termsAndConditions.get('acceptProtectionPolicy') as FormControl;
  }
  get  emailControl(): FormControl {
    return this.RescheduleForm.get("email") as FormControl;
  }

}
